export default __webpack_public_path__ + "static/media/vmeduLogo.4807b3c2.svg";